<template>
    <div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAll">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="value" @change="handleCheck">
            <el-checkbox v-for="item in items" :label="item" :key="item">{{item}}</el-checkbox>
        </el-checkbox-group>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: ['val','items'],
        data() {
            return {
                isIndeterminate: true,
                checkAll : false,
                value: []
            }
        },

        methods: {
            handleCheckAll(val){
                this.value = val ? this.items : [];
                this.isIndeterminate = false;
                this.$emit('value',this.value);
            },
            handleCheck(val) {
                let len = val.length;
                this.checkAll = len === this.items.length;
                this.isIndeterminate = len > 0 && len < this.items.length;
                this.$emit('value',this.value);
            }
        },

        watch: {
            val(val) {
                let newVal = JSON.stringify(val);
                this.value = JSON.parse(newVal);
            }
        }
    }
</script>

<style scoped>

</style>